import './profile.css'
import {useAuthValue} from './AuthContext'
import { signOut } from 'firebase/auth' 
import { auth, db } from './firebase'
import {useState, useEffect} from 'react'
import {
     collection,
    // getDocs,
     doc,
     getDoc,
     addDoc,
     Timestamp,
     //updateDoc,
     //deleteDoc,
     //doc,
    // query,
    // where
   } from "firebase/firestore";
import {useNavigate, useLocation} from 'react-router-dom'
import logoImg1 from './assets/logoG.png';


   function ConfirmDataCash() {
    //const {currentUser} = useAuthValue()
    const navigate = useNavigate()
    const location = useLocation()
    const {currentUser} = useAuthValue()
    const [error, setError] = useState('')
    const [dadosEmp, setDadosEmp] = useState([])
    const [loading, setLoading] = useState(true)
   // const [numnf, setNumnf] = useState(0);
    const prestservCollectionRef = collection(db, "registrosPrestServ");
 
   // const { stateParam } = useLocation();
   // console.log("UsuarioLogado: "+currentUser.uid)
   // console.log("Grupo cliente:")

    
  const sendWhatsRegCash = (clinome, cligrupo,funcname, mailfunc, empresacred, foneclicash, valorpagto, valcashb, chaveid)  => {
    
    // Send data to the backend via POST
    fetch('https://api.callmebot.com/whatsapp.php?phone=556392150988&text=O+usuario+'+foneclicash+'+=>+'+clinome+'+do+'+cligrupo+'+foi+até+a+empresa+'+empresacred+'+||+funcionário:+('+mailfunc+'+=>+'+funcname+')+fez+uma+compra+no+valor+de+R$+'+valorpagto+'+e+gerou+R$+'+valcashb+'+de+Cashback+pelo+site.+CHAVE:+'+chaveid+'+&apikey=9548891', {  // Enter your IP address here

      method: 'POST', 
      mode: 'cors', 
     //body: JSON.stringify(jsonData) // body data type must match "Content-Type" header

    })
    
  }

    const validateCashback = () => {
        let isValid = true
        
          if ( currentUser.uid == null) {
            isValid = false
            setError('Usuario nao logado')
          }
        sendSMS(location.state.foneUser, dadosEmp.nomeFantasia, removeDolar(location.state.valor).toFixed(2), parseFloat((removePerc(dadosEmp.porcentdesc)*removeDolar(location.state.valor))*0.8).toFixed(2), location.key)
        //navigate('/cashbackSuccess')
        sendWhatsRegCash(location.state.name, location.state.grupoCli, location.state.nomeUsrReg, currentUser.uid,dadosEmp.nomeFantasia,location.state.foneUser,removeDolar(location.state.valor).toFixed(2), parseFloat((removePerc(dadosEmp.porcentdesc)*removeDolar(location.state.valor))*0.8).toFixed(2), location.key)
        navigate('/cashbackSuccess',{state:{foneClie: location.state.foneUser, nomeEmpr: dadosEmp.nomeFantasia, valorServ: removeDolar(location.state.valor).toFixed(2), valorCash: parseFloat((removePerc(dadosEmp.porcentdesc)*removeDolar(location.state.valor))*0.8).toFixed(2), codLanc: location.key, nomeCli: location.state.name}});
        
        return isValid
      }
      
      const sendSMS = async (telCliente, nomeEmpresa, valorServico, cashbackcliente, codnumnf) => {
        //const sendSMS = async (title, body) => {
          //const sendSMS = async (numDestin, empresa, ValorCompra, ValorCashbask, cod) => {
           // console.log(removemaskPhone(telCliente));
           // console.log("Empresa: "+nomeEmpresa)
           // console.log("Valor Servico: "+valorServico)
           // console.log("Cashback Cliente: "+cashbackcliente)
           // console.log("Codigo: "+codnumnf)
          await fetch('http://corporativo.allcancesms.com.br/app/modulo/api/index.php?action=sendsms&lgn=SUPREMA10&pwd=0988&msg=TOPago+Cashback+informa:+Cod+da+Compra+na+empresa+'+nomeEmpresa+'no+valor+de+R$+'+valorServico+'+é+:+'+codnumnf+'+&numbers='+removemaskPhone(telCliente)+'', {
          method: 'POST',
          /*body: JSON.stringify({
            title: title,
            body: body,
            userId: Math.random().toString(36).slice(2),
          }),*/
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
                          'Access-Control-Allow-Origin':'*',
                          'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS'
          },
          })
          .then((response) => response.json())
          .then((data) => {
           // setPosts((posts) => [data, ...posts]);
           // setTitle('');
           // setBody('');
            console.log(data)
            console.log('enviei')
          })
          .catch((err) => {
            console.log(err.message);
          });
        };
      
    const removeDolar = (valreal) => {
        
        const valorsreal =  parseFloat(valreal?.replace("R$ ", '')?? 0);
        return parseFloat(valorsreal);
    }


    const removePerc = (valperc) => {
      const percent0 =  parseFloat(valperc?.replace(/[^0-9]/g, '')?? 0);
      return parseFloat(percent0/100); 
    }


    const removemaskPhone = (valphonenum) => {
      const nummob =  valphonenum?.replace(/[^0-9]/g, '') ?? 0;
      return nummob; 
    }

    const docRef = doc(db, "empresas", location.state.empVinc);
    const getEmpresadata = async () => {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setDadosEmp(docSnap.data())

      } else {
        console.log("No such document!");
        setLoading(false)
      }
      if (loading) {
        setLoading(false);
      }
    }

    const registraCashback = () => {
        
        setError('')
       // setNumnf(location.state.key);
      
        if(validateCashback()) {
          return addDoc(prestservCollectionRef, {
            valorServ: location.state.valor,
            funcioResponReg: currentUser.uid,
            clienteUID: location.state.idcli,
            clienteEmail:location.state.emailcli,
            clienteNome: location.state.name,
            status: null,
            NfNumber:location.key,
           // documUser: cpf,
           // foneUser:telefone,
           // grupoparceiro: valuegrup,
            prestserv: false,
          //  emailUser: email,
            dataLanc: null,
            //dataCadastro:  Math.floor(Date.now()/1000),
            readedAt:  Timestamp.fromDate(new Date()),
           // userFire: user.uid
        })  
        .catch((err) => alert(err.message))
        
      }
      } 
      
      useEffect(() => {
        console.log(location)
        getEmpresadata();
      }, [loading])

    return (
        <div className='center'>
          <div className='profile'>
            
            <img src={logoImg1} width="150" height="150" alt='Logo'/>
            <h1>Confirme os dados!</h1>
             <p><strong>Confira novamente os dados do cliente e o valor do serviço prestado:</strong></p>
             <p><strong>Cliente:</strong> {location.state.name} </p>
             <p><strong>Grupo:</strong> {location.state.grupoCli} </p>
             <p><strong>Valor Pago:</strong> {location.state.valor} </p>
            
             <hr/>
             <p><strong>Usuário:</strong> {location.state.nomeUsrReg}</p>
             <p><strong>Empresa:</strong> {dadosEmp.nomeFantasia}</p>
             <p><strong>CNPJ:</strong> {dadosEmp.cnpj}</p>
             <p><strong>Percent Cashback:</strong> {dadosEmp.porcentdesc}</p>
             <p><strong>Cashback:</strong> R$ {parseFloat((removePerc(dadosEmp.porcentdesc)*removeDolar(location.state.valor))/10).toFixed(2)}</p>
             <p><strong>Cashback Cliente:</strong> R$ {parseFloat(((removePerc(dadosEmp.porcentdesc)*removeDolar(location.state.valor))*0.8)/10).toFixed(2)}</p>
             <button onClick={() => navigate(-1)} style={{backgroundColor:"orangered",  color:'white'}}>Corrigir</button> - - || - - <button onClick={() => registraCashback()} style={{backgroundColor:"green",  color:'white'}}>Confirmar</button>
            </div>
        </div>
        )
   } 


   export default ConfirmDataCash